/**
 * Theme context – light / dark / system preference. Provider lives in ThemeProvider.tsx.
 */

import {
  createContext,
  use,
} from 'react';

export type ThemePreference = 'system' | 'light' | 'dark';

export type ThemeContextValue = {
  /** Effective theme for UI (follows system when preference is 'system') */
  isDark: boolean;
  /** User's stored preference; default 'system' */
  preference: ThemePreference;
  /** Set preference and persist; use 'light' | 'dark' to override system */
  setPreference: (next: ThemePreference) => void;
  /** Toggle between light and dark (writes 'light' or 'dark', no longer 'system') */
  toggleTheme: () => void;
};

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme(): ThemeContextValue {
  const ctx = use(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
